import { create } from "zustand";

const useCreateNotes = create((set) => ({
  showCreateSession: true,
  showGenerateNotes: false,
  showSaveSession: false,
  showCoreBox: false,
  timerTick: 0,
  hasInitialAutoSaved: false,
  hasRecommendationBeenClickedOnce: false,
  recommendation: '',
  modeCliked: 0,
  sessionStatus: 'idle', // 'idle' | 'in_progress' | 'completed'
  sessionRestoreKey: 0,
  sessionSource: 'new', // 'new' | 'history_continue'
  isGeneratingNotes: false,

  setSessionStatus: (status) =>
    set({ sessionStatus: status }),

  setIsGeneratingNotes: (value) =>
    set({ isGeneratingNotes: value }),

  restoreSession: ({ sessionId, patientName, timerTick, transcribedText, generatedNotes, selectedTemplates }) =>
    set((state) => ({
      currentSession: { id: sessionId },
      currentPatient: { firstName: patientName || 'Untitled' },
      timerTick: timerTick || 0,
      transcribedText: transcribedText || '',
      generatedNotes: generatedNotes || [],
      selectedTemplates: selectedTemplates || [],
      showCoreBox: (generatedNotes || []).length > 0,
      sessionStatus: 'in_progress',
      changesMade: true,
      hasInitialAutoSaved: (generatedNotes || []).length > 0,
      recommendation: '',
      sessionRestoreKey: state.sessionRestoreKey + 1,
      sessionSource: 'history_continue',
    })),

  setHasInitialAutoSaved: (value) =>
    set((state) => ({
      ...state,
      hasInitialAutoSaved: value,
    })),

  setHasRecommendationBeenClickedOnce: (value) =>
    set({ hasRecommendationBeenClickedOnce: value }),

  setModeCliked: (value) =>
    set({ modeCliked: value }),

  setRecommendation: (value) =>
    set({ recommendation: value }),

  setShowCreateSession: () =>
    set((state) => ({
      ...state,
      showCreateSession: true,
      showGenerateNotes: false,
      showSaveSession: false,
    })),

  appendTranscription: (text) =>
    set((state) =>
      ({ transcribedText: state.transcribedText + " " + text })),

  setTimerTick: (valueOrFn) =>
    set((state) => ({
      timerTick:
        typeof valueOrFn === "function"
          ? valueOrFn(state.timerTick)
          : valueOrFn,
    })),

  startTimer: () =>
    set((state) => {
      if (state._intervalId) return {};
      const intervalId = setInterval(() => {
        state.setTimerTick((t) => t + 1);
      }, 1000);
      return { _intervalId: intervalId };
    }),

  stopTimer: () => set((state) => {
    if (state._intervalId) clearInterval(state._intervalId);
    return { _intervalId: null };
  }),

  setShowSaveSession: () =>
    set((state) => ({
      ...state,
      showCreateSession: false,
      showGenerateNotes: false,
      showSaveSession: true,
    })),
  setShowCoreBox: () =>
    set((state) => ({
      ...state,
      showCoreBox: true,
    })),
  setShowGenerateNotes: () =>
    set((state) => ({
      ...state,
      showCreateSession: false,
      showGenerateNotes: true,
      showSaveSession: false,
    })),

  patientConsent: null,
  setPatientConsent: (consent) =>
    set((state) => ({
      ...state,
      patientConsent: consent,
    })),

  currentPatient: null,
  setCurrentPatient: (patient) =>
    set((state) => ({
      ...state,
      currentPatient: patient,
    })),

  currentSession: null,
  setCurrentSession: (session) =>
    set((state) => ({
      ...state,
      currentSession: session,
    })),

  selectedTemplates: [],
  setSelectedTemplates: (templates) =>
    set((state) => ({
      ...state,
      selectedTemplates: templates,
    })),

  generatedNotes: [],
  setGeneratedNotes: (notes) =>
    set((state) => ({
      ...state,
      generatedNotes: notes,
    })),

  currentAudioBlob: null,
  setCurrentAudioBlob: (audioBlob) =>
    set((state) => ({
      ...state,
      currentAudioBlob: audioBlob,
    })),

  transcribedText: "",
  setTranscribedText: (text) =>
    set((state) => ({
      ...state,
      transcribedText: text,
    })),

  changesMade: false,
  setChangesMade: (changeMade) =>
    set((state) => ({
      ...state,
      changesMade: changeMade,
    })),

  shouldShowSaveSession: false,
  setShouldShowSaveSession: (show) =>
    set((state) => ({
      ...state,
      shouldShowSaveSession: show,
    })),

  resetSessionStates: () =>
    set(() => ({
      changesMade: false,
      generatedNotes: [],
      transcribedText: "",
      currentSession: null,
      currentPatient: null,
      patientConsent: null,
      selectedTemplates: [],
      showSaveSession: false,
      currentAudioBlob: null,
      showCreateSession: true,
      showGenerateNotes: false,
      shouldShowSaveSession: false,
      showCoreBox: false,
      timerTick: 0,
      hasInitialAutoSaved: false,
      sessionStatus: 'idle',
      sessionRestoreKey: 0,
      sessionSource: 'new',
      isGeneratingNotes: false,
    })),
}));

export default useCreateNotes;